import { createFileRoute } from '@tanstack/react-router'
import { StatusReportEditorPage } from '../../../../../../features/projects/status-reports/report-editor-page'

/** A weekly status report: written while DRAFT, read when FINAL (P7). */
export const Route = createFileRoute('/_app/projects/$projectId/reports/$reportId/')({
  staticData: { crumb: 'projectReport' },
  component: StatusReportEditorPage,
})
